// AUTO-GENERATED by /app/frontend/scripts/generate-build-info.js
// Do not edit by hand; this file is regenerated on every `yarn start` /
// `yarn build`.

export const BUILD_VERSION = "v2026.11.04-1914";
export const BUILD_SHA = "";
export const BUILD_TIME_ISO = "2026-11-04T19:14:07.858Z";
